import { Trans } from 'react-i18next';

import PaymentStore from '@/services/payments/PaymentStore';

export function BankTransferDetails() {
  switch (PaymentStore.legalEntity) {
    case 2310000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2310000_Info'} />;
    case 2401009:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2401009_Info'} />;
    case 1900019:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_1900019_Info'} />;
    case 910110:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_910110_Info'} />;
    case 441000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_441000_Info'} />;
    case 790300:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_790300_Info'} />;
    case 500000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_500000_Info'} />;
    case 890050:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_890050_Info'} />;
    case 2301030:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2301030_Info'} />;
    case 464000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_464000_Info'} />;
    case 441001:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_441001_Info'} />;
    case 7010000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_7010000_Info'} />;
    case 2900200:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2900200_Info'} />;
    case 2901000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2901000_Info'} />;
    case 2810000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2810000_Info'} />;
    case 7900000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_7900000_Info'} />;
    case 800555:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_800555_Info'} />;
    case 800990:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_800990_Info'} />;
    case 66005000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_66005000_Info'} />;
    case 750005:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_750005_Info'} />;
    case 2610000:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_2610000_Info'} />;
    case 7300050:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_7300050_Info'} />;
    case 8400660:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_8400660_Info'} />;
    case 7010700:
      return <Trans i18nKey={'OfflinePayment_BankTransfer_7010700_Info'} />;
    default:
      return null;
  }
}
